import React from "react";
import DefaultFormLayout from "../../components/form/DefaultFormLayout/DefaultFormLayout";
import FieldSelector from "../../shared/form/components/FieldSelector";
import { useCreateUpdate } from "../../shared/form/hooks/useCreateUpdate";
import { CUEntityFormPropsType, UIFormInterface } from "../../shared/form/types/CRUDTypes";
import { CrudFormType } from "../../shared/form/types/FormTypes";
import { useLangLabels } from "../../shared/lang/services/useLangLabels";
import { useSessionContext } from "../session/store/sessionContext";
import { CriticalityInterface } from "./models/criticalityInterface";

import {
  CreateCriticality,
  criticalityCRUDDependencies,
  DeleteCriticality,
  UpdateCriticality,
} from "./services/service.criticality";
import { useCriticalityForm } from "./services/useCriticalityForm";

type props = CUEntityFormPropsType<CriticalityInterface> & { isDataUpdated?: boolean };

const CUCriticalityForm: React.FC<props> = ({ actionType, item, isDataUpdated }) => {
  const { tagFP } = useSessionContext();
  //DB
  const { action, resetStatus, status, error, message } = useCreateUpdate(
    {
      create: CreateCriticality,
      update: UpdateCriticality,
      delete: DeleteCriticality,
    },
    actionType,
    criticalityCRUDDependencies
  );

  //UI
  const { lang } = useLangLabels();

  const { uiModel, handleSubmit, resetForm } = useCriticalityForm(tagFP, item);
  const ui = (() => {
    const formName = lang.criticalities.title.singular;
    switch (actionType) {
      case CrudFormType.create:
        const create: UIFormInterface = {
          icon: "add",
          title: `${lang.actionTypes.create} ${formName}`,
          variant: "button",
          mode: "modal",
        };
        return create;

      case CrudFormType.update:
        const update: UIFormInterface = {
          icon: "edit",
          title: `${lang.actionTypes.update} ${formName}`,
          variant: "iconButton",
          mode: "content",
        };
        return update;
    }
  })();

  //Methods
  const submit = (data: CriticalityInterface) => {
    action(data);
  };

  const handleReset = () => {
    resetStatus();
    resetForm();
  };

  return (
    <DefaultFormLayout
      componentMode={ui.mode}
      buttonIcon={ui.icon}
      buttonVariant={ui.variant}
      buttonText={ui.title}
      popoverTitle={ui.title}
      {...{ queryStatus: status, error, alertStatusMessage: message }}
      buttonAction={handleSubmit(submit)}
      onClose={handleReset}
      resetForm={handleReset}
      isDataUpdated={isDataUpdated}
    >
      {uiModel.map((props, _index) => (
        <FieldSelector key={props.name} fieldProps={props} />
      ))}
    </DefaultFormLayout>
  );
};

export default React.memo(CUCriticalityForm);
